import language from "@/templates/Admin/variants/default/utils/services/language";

const withIdPath = (endpoint: string, id_path?: string) => {
    const separator = endpoint.includes('?') ? '&' : '?';
    return id_path ? `${endpoint}${separator}id_path=${encodeURIComponent(id_path)}` : endpoint;
};

const apiEndPointList = {
    cmc: {
        UPLOAD_TO_S3: (id_path: string) => `/v1/projects/cmc/upload?id_path=${id_path}`,
    },
    language: {
        GET_LANGUAGE_DEFAULT: (id_path?: string) => withIdPath(`v1/projects/language/default`, id_path),
        GET_ALL_LANGUAGE: (id_path?: string) => withIdPath(`v1/projects/language`, id_path),

    },

    groupView: {
        GET_ALL_PARENT_GROUP: ({ id_path, language, page, limit, version_id, scene_name, is_show }: { id_path: string; language: string; page: string; limit: string; version_id: string; scene_name?: string; is_show?: string }) => {
            const baseUrl = `/v1/projects/group/parents?&language_id=${language}&page=${page}&limit=${limit}&version_id=${version_id}&is_show=${is_show}`;
            const urlWithSceneName = scene_name ? `${baseUrl}&scene_name=${encodeURIComponent(scene_name)}` : baseUrl;
            return withIdPath(urlWithSceneName, id_path);
        },
        GET_GROUP_BY_ID: ({ id_path, language, id_group }: { id_path: string; language: string; id_group: string }) => `/v1/projects/group/${id_group}?id_path=${id_path}&language_id=${language}`,
        // GET_ALL_PARENT_GROUP: ({ id_path, language, version_id }: { id_path: string; language: string; version_id: string }) => withIdPath(`v1/projects/group/parents?language_id=${language}&version_id=${version_id}`, id_path),
        SEARCH_ADVANCE: ({ id_path, key_work, parent_group_id, language_id, version_id, page, limit }: { id_path: string; key_work: string; parent_group_id?: string; language_id?: string; version_id?: string; page?: string; limit?: string }) => `/v1/projects/group/search/?id_path=${id_path}&keyword=${key_work}&parent_group_id=${parent_group_id || ''}&language_id=${language_id}&version_id=${version_id}&page=${page}&limit=${limit}`,
        GET_ALL_CHILD_GROUP_BY_GROUP: ({ id_path, language, id_group, versionId }: { id_path: string; language: string; id_group: string, versionId: string }) => withIdPath(`/v1/projects/group/${id_group}/children?language_id=${language}&version_id=${versionId}`, id_path),
        GET_CHILD_GROUP_OR_SCENE_BY_GROUP: ({ id_path, id_group, language }: { id_path: string; id_group: string; language: string; }) => `/v1/projects/group-scene/nested/group/${id_group}/${language}?id_path=${id_path}`,

        GET_GROUP_OF_CURRENT_SCENE: ({ id_path, scene_id, language }: { id_path: string; scene_id: string; language: string; }) => `/v1/projects/group-scene/scene/${scene_id}/${language}?id_path=${id_path}`,
        GET_GROUP_PARENT_BY_GROUP: ({ id_path, group_id, language }: { id_path: string; group_id: string; language: string; }) => {
            // console.log('GET_GROUP_PARENT_BY_GROUP', { id_path, group_id, language });
            return `/v1/projects/group/${group_id}/parent?id_path=${id_path}&language_id=${language}`;
        },
        GET_ALL_VERSION_GROUP: ({ id_path }: { id_path: string }) => withIdPath(`/v1/projects/group-versions`, id_path),
        GET_GROUP_BY_UUID: ({ id_path, language, group_uuid }: { id_path: string; language: string; group_uuid: string }) => `/v1/projects/group/uuid/${group_uuid}?id_path=${id_path}&language_id=${language}`,

    },
    hotspot: {
        GET_HOTSPOT_BY_SCENE_NAME: (sceneName: string, id_path: string, locale: string) => withIdPath(`/v1/projects/hotspot/scene-name/${sceneName}?language_id=${locale}`, id_path),
    },
    polygonHotspot: {
        GET_ALL_MULTI_MEDIA_BY_SCENE_NAME: (sceneName: string, id_path: string, locale: string, is_public?: number) => {
            let url = `v1/projects/multi-media/scene/${sceneName}?language_id=${locale}`;
            if (is_public !== undefined) {
                url += `&is_public=${is_public}`;
            }
            return withIdPath(url, id_path);
        }
    },
    scene: {
        GET_ALL_SCENE: (id_path: string, language_id: string) => withIdPath(`/v1/projects/scene?language_id=${language_id}`, id_path),
        GET_PREVIOUS_SCENE_BY_SCENE_NAME: (sceneName: string, id_path: string, language_id: string) => `/v1/projects/scene/name/${encodeURIComponent(sceneName)}/previous?id_path=${id_path}&language_id=${language_id}`,
        GET_NEXT_SCENE_BY_SCENE_NAME: (sceneName: string, id_path: string, language_id: string) => `/v1/projects/scene/name/${encodeURIComponent(sceneName)}/next?id_path=${id_path}&language_id=${language_id}`,
        GET_GROUP_AND_SCENE_BELONG_GROUP: ({ group_id, id_path, language_id }: { group_id: string; id_path: string; language_id: string }) => `/v1/projects/group-scene/detail/${group_id}/${language_id}?id_path=${id_path}`,

        GET_SCENE_BY_SCENE_NAME: ({ id_path, language, scene_name, gender }: { id_path: string; language: string; scene_name: string; gender: string }) => withIdPath(`v1/projects/scene/name/${encodeURIComponent(scene_name)}?language_id=${language}&gender=${gender}`, id_path),
        GET_SCENE_BY_SCENE_ID_FROM_HOTSPOT: ({ id_path, language, scene_id }: { id_path: string; language: string; scene_id: string; }) => withIdPath(`v1/projects/scene/hotspot/${scene_id}?language_id=${language}`, id_path),
        GET_SCENE_BY_ID: ({ id_path, language, scene_id, gender }: { id_path: string; language: string; scene_id: string; gender: string }) => withIdPath(`v1/projects/scene/${scene_id}?language_id=${language}&gender=${gender}`, id_path),
        GET_INFORMATION_FOR_SCENE_AND_GROUP_BY_SCENE_NAME: ({ id_path, language, scene_name }: { id_path: string; language: string; scene_name: string }) => withIdPath(`v1/projects/group-scene/scene-with-group/${scene_name}/${language}`, id_path),
        INCREMENT_SCENE_VIEW: (sceneName: string, id_path: string) => withIdPath(`v1/projects/scene/name/${encodeURIComponent(sceneName)}/increment-view`, id_path),
    },
    gallery: {
        GET_ALL_ASSET: (id_path?: string) => withIdPath(`/v1/projects/asset`, id_path),
        GET_ASSET_BY_TYPE: (page: number, limit: number, language_id: string, id_path?: string) => withIdPath(`/v1/projects/asset/type/1?page=${page}&limit=${limit}&language_id=${language_id}`, id_path),
        GET_ASSET_BY_ID: (id: string, id_path?: string, language_id?: string) => {
            const query = language_id ? `?language_id=${language_id}` : '';
            return withIdPath(`/v1/projects/asset/${id}${query}`, id_path);
        },
        INCREMENT_ASSET_VIEW: (uuid: string, id_path: string) => withIdPath(`/v1/projects/asset/uuid/${uuid}/increment-view`, id_path),
        SEARCH_ASSET_BY_TYPE_AND_KEYWORD: (keyword: string, language_id: string, id_path?: string) =>
            withIdPath(`/v1/projects/asset/search?keyword=${keyword}&type_id=1&language_id=${language_id}`, id_path),
        GET_ALL_ASSET_WITH_CATEGORY_BY_TYPE: (id_path?: string, language_id?: string) =>
            withIdPath(`/v1/projects/asset/categories-with-assets/type/1?language_id=${language_id}`, id_path),
        GET_ASSET_BY_CATEGORY: (category_id: string, limit: number, page: number, idPath?: string) => withIdPath(`/v1/projects/asset/category/${category_id}?page=${page}&limit=${limit}`, idPath),
        GET_CATEGORY_COUNTS: (category_uuid: string, idPath?: string) =>
            withIdPath(`/v1/projects/asset/category/${category_uuid}/counts`, idPath),
        GET_CATEGORY_GROUP_BY_ASSET_TYPE: (type: string, language_id: string, id_path?: string) =>
            withIdPath(`/v1/projects/asset/type/${type}/parents?language_id=${language_id}`, id_path),
        GET_MODEL_RELATED_ASSETS: (id_path: string, language_id: string, parent_category_uuid: string, asset_type: number, level: number = 3) =>
            withIdPath(`/v1/projects/asset/type/${asset_type}/categories-or-assets?language_id=${language_id}&parent_category_uuid=${parent_category_uuid}&level=${level}`, id_path),
    },
    material: {
        GET_ASSET_BY_TYPE: ({
            id_path,
            type,
            page,
            limit,
            language_id,
        }: {
            id_path: string;
            type: string;
            page: string;
            limit: string;
            language_id: string;
        }) => `/v1/projects/asset/type/${type}?id_path=${id_path}&page=${page}&limit=${limit}&language_id=${language_id}`,

        GET_ASSET_BY_CATEGORY: (category_id: string, limit: number, page: number, id_path?: string) => withIdPath(`/v1/projects/asset/category/${category_id}?page=${page}&limit=${limit}`, id_path),
        GET_CATEGORY_GROUP_BY_ASSET_TYPE: (type: string, id_path?: string) =>
            withIdPath(`/v1/projects/asset/type/${type}/parents`, id_path),
        SEARCH_ASSET_BY_TYPE_AND_KEYWORD: (keyword: string, language_id: string, id_path: string, typeId: number) =>
            withIdPath(`/v1/projects/asset/search?keyword=${keyword}&type_id=${typeId}&language_id=${language_id}`, id_path),

        GET_NESTED_CATEGORIES: (id_path: string, type_id: any, language_id?: string) =>
            withIdPath(`/v1/projects/asset/type/${type_id}/nested-categories?language_id=${language_id}`, id_path),

        GET_NESTED_CATEGORIES_WITH_ASSETS: (id_path: string, type_id: any, language_id?: string) =>
            withIdPath(`/v1/projects/asset/type/${type_id}/nested-categories-with-assets?language_id=${language_id}`, id_path),

        // GET_NESTED_CATEGORIES_WITH_SEARCH: (id_path: any, type_id: any, language_id?: string, search?: string, link_id?: string) => {
        //     const params = new URLSearchParams();
        //     params.append('language_id', language_id || 'vn');
        //     if (search) params.append('search', search);
        //     if (link_id) params.append('link_id', link_id);

        //     const endpoint = `/v1/projects/asset/type/${type_id}/nested-search?${params.toString()}`;
        //     console.log('GET_NESTED_CATEGORIES_WITH_SEARCH endpoint:', endpoint);
        //     return withIdPath(endpoint, id_path);
        // },

        GET_NESTED_CATEGORIES_WITH_SEARCH: (id_path: any, type_id: any, language_id?: string, search?: string, link_id?: string) =>
            withIdPath(`/v1/projects/asset/type/${type_id}/nested-search?search=${search}&language_id=${language_id}${link_id ? `&link_id=${link_id}` : ''}`, id_path),


        GET_ASSETS_BY_RECURSIVE_CATEGORY: ({
            category_uuid,
            link_id,
            id_path,
            language_id = 'vn',
            page = 1,
            limit = 10,
            type,
            type_value,
        }: {
            category_uuid: string;
            link_id?: string;
            id_path?: string;
            language_id?: string;
            page?: number;
            limit?: number;
            type?: string;
            type_value?: string;
        }) => {
            const params = new URLSearchParams();
            params.append('language_id', language_id);
            params.append('page', page.toString());
            params.append('limit', limit.toString());
            if (type) params.append('type', type);
            if (type_value) params.append('type_value', type_value);

            const endpoint = `/v1/projects/asset/category/${category_uuid}/recursive${link_id ? `/${link_id}` : ''}?${params.toString()}`;
            return withIdPath(endpoint, id_path);
        },

        SEARCH_ASSETS_ADVANCED: ({
            keyword,
            category_uuid,
            asset_type_id,
            is_category = false,
            language_id = 'vn',
            page = 1,
            limit = 10,
            is_show,
            approve,
            sort_by = 'index',
            sort_order = 'ASC',
            id_path
        }: {
            keyword?: string;
            category_uuid?: string;
            asset_type_id?: number;
            is_category?: boolean;
            language_id?: string;
            page?: number;
            limit?: number;
            is_show?: number;
            approve?: number;
            sort_by?: string;
            sort_order?: string;
            id_path?: string;
        }) => {
            const params = new URLSearchParams();

            if (keyword) params.append('keyword', keyword);
            if (category_uuid) params.append('category_uuid', category_uuid);
            if (asset_type_id !== undefined) params.append('asset_type_id', asset_type_id.toString());
            params.append('is_category', is_category.toString());
            params.append('language_id', language_id);
            params.append('page', page.toString());
            params.append('limit', limit.toString());
            if (is_show !== undefined) params.append('is_show', is_show.toString());
            if (approve !== undefined) params.append('approve', approve.toString());
            params.append('sort_by', sort_by);
            params.append('sort_order', sort_order);

            const endpoint = `/v1/projects/asset/search/advanced?${params.toString()}`;
            return withIdPath(endpoint, id_path);
        },

        CHECK_ASSET_TYPES_DATA: (id_path: string) => withIdPath(`/v1/projects/asset/types/check-data`, id_path),
    },
    autotour: {
        GET_ALL_AUTOTOURS: (id_path: string, page: string, limit: string, language_id: string) => withIdPath(`/v1/projects/autotour?page=${page}&limit=${limit}&language_id=${language_id}&only_visible=true`, id_path),
        GET_ALL_AUTOTOURS_DETAILS_BY_ID: (id_path: string, autotour_id: string, language_id: string) => withIdPath(`/v1/projects/autotour/${autotour_id}?language_id=${language_id}`, id_path),
    },
    minimap: {
        GET_ALL_MINIMAPS: (id_path: string, language_id: string) => withIdPath(`/v1/projects/minimap?is_public=1&language_id=${language_id}&sort=index&order=ASC`, id_path),
        GET_MAIN_MINIMAPS: (id_path: string, language_id: string) => withIdPath(`/v1/projects/minimap/mainmap?is_public=1&language_id=${language_id}`, id_path),
        GET_MINIMAP_BY_ID: (id_path: string, minimap_id: string, language_id?: string) => withIdPath(`/v1/projects/minimap/${minimap_id}?is_public=1&language_id=${language_id}`, id_path),
        // Add is_public=1 filter to show only public markers on product page
        GET_MINIMAP_AND_MARKER_LOCATION_BY_ID: (id_path: string, map_id: number, language_id: string) => withIdPath(`/v1/projects/minimap/${map_id}/locations?language_id=${language_id}&is_public=1`, id_path),
        GET_ALL_LOCATION: (id_path: string) => withIdPath(`/v1/projects/minimap/locations`, id_path),
        GET_LOCATION_BY_ID: (id_path: string, location_id: string) => withIdPath(`/v1/projects/minimap/locations/${location_id}`, id_path),
        GET_NESTED_GROUPS_WITH_MARKERS: (id_path: string, minimap_id: number, language_id?: string) => {
            let url = `/v1/projects/minimap/groups/nested?id_path=${id_path}&minimap_id=${minimap_id}`;
            if (language_id) url += `&language_id=${language_id}`;
            return url;
        },
        // Polygon endpoints - only show public polygons on product page
        GET_POLYGONS_BY_MINIMAP: (id_path: string, minimap_id: number, language_id?: string) => {
            let url = `/v1/projects/minimap/${minimap_id}/polygons?id_path=${id_path}&is_public=1`;
            if (language_id) url += `&language_id=${language_id}`;
            return url;
        },
    },
    videoGroup: {
        GET_VIDEO_GROUP_BY_SCENE: (sceneiD: string, id_path: string) => withIdPath(`v1/projects/video-group/scene/${sceneiD}?`, id_path),
    },
    googlemap: {
        GET_ALL_GOOGLE_MAP: (id_path: string) => withIdPath(`/v1/projects/google-map`, id_path),
        GET_ALL_LOCATION: (id_path: string, language_id: string) =>
            withIdPath(`/v1/projects/google-map-locations?language_id=${language_id}`, id_path),
        GET_GOOGLE_MAP_KEY: (id_path: string) =>
            withIdPath(`/v1/general/google/google-api-key`, id_path),
        GET_DIRECTIONS: (origin: string, destination: string) =>
            `/v1/general/google-directions?origin=${encodeURIComponent(origin)}&destination=${encodeURIComponent(destination)}`,
    },

    contact: {
        GET_ALL_CONTACTS: (id_path: string) => withIdPath(`/v1/projects/contact`, id_path),
        GET_ALL_CONTACT_BY_SUBLINK: ({ id_path, sublink }: { id_path: string; sublink: string }) => withIdPath(`/v1/projects/contact/by-sublink?sublink=${sublink}`, id_path),
    },

    metadata: {
        GET_ALL_VARIABLE_SETTING_AND_VALUE: (id_path: string) => withIdPath(`v1/projects/settings/categories/1/key-value`, id_path),
    },

    setting: {
        GET_CATEGORIES_SETTING_BY_NAME: (
            name: string,
            language_id: string,
            id_path?: string,
            link_id?: string,
            default_language?: string,
            fallback_link?: boolean,
            fallback_language?: boolean
        ) => {
            const normalizedLinkId = (!link_id || link_id === 'undefined' || link_id === 'null') ? '1' : link_id;
            let url = `/v1/projects/settings/values/by-uuid/${name}?language_id=${language_id}&link_id=${normalizedLinkId}`;
            if (default_language) url += `&default_language=${encodeURIComponent(default_language)}`;
            if (fallback_link) url += `&fallback_link=true`;
            if (fallback_language) url += `&fallback_language=true`;
            return withIdPath(url, id_path);
        },
    },
    sublink: {
        // GET_PARENT_GROUP_BY_SUBLINK: ({ id_path, language, page, limit, version_id, scene_name }: { id_path: string; language: string; page: string; limit: string; version_id: string; scene_name?: string }) => withIdPath(`/v1/projects/sublink/${sublink}/parent-group`, id_path),
        GET_PARENT_GROUP_BY_SUBLINK: ({ id_path, language, page, limit, version_id, scene_name, sublink, show_children_groups }: { id_path: string; language: string; page: string; limit: string; version_id: string; scene_name?: string, sublink: string, show_children_groups?: string }) => {
            const baseUrl = `/v1/projects/sublink/${sublink}/parent-groups?language_id=${language}&page=${page}&limit=${limit}&version_id=${version_id}&show_children_groups=${show_children_groups}`;
            const urlWithSceneName = scene_name ? `${baseUrl}&scene_name=${encodeURIComponent(scene_name)}` : baseUrl;
            return withIdPath(urlWithSceneName, id_path);
        },
        GET_PARENT_GROUP_BY_SUBLINK_FOR_HOME_SCREEN: ({ id_path, language, page, limit, version_id, scene_name, sublink, show_children_groups }: { id_path: string; language: string; page: string; limit: string; version_id: string; scene_name?: string, sublink: string, show_children_groups?: string }) => {
            const baseUrl = `/v1/projects/sublink/${sublink}/parent-groups-by-sublink?language_id=${language}&page=${page}&limit=${limit}&version_id=${version_id}&show_children_groups=${show_children_groups}`;
            const urlWithSceneName = scene_name ? `${baseUrl}&scene_name=${encodeURIComponent(scene_name)}` : baseUrl;
            return withIdPath(urlWithSceneName, id_path);
        },
        GET_NEXT_SCENE_BY_SCENE_NAME_SUBLINK: (sceneName: string, id_path: string, language_id: string, sublink: string) => `/v1/projects/sublink/scene/${sceneName}/next?id_path=${id_path}&language_id=${language_id}&link_id=${sublink}`,
        GET_PREVIOUS_SCENE_BY_SCENE_NAME_SUBLINK: (sceneName: string, id_path: string, language_id: string, sublink: string) => `/v1/projects/sublink/scene/${sceneName}/previous?id_path=${id_path}&language_id=${language_id}&link_id=${sublink}`,
        GET_HOTSPOTS_BY_SCENE_NAME_SUBLINK: (sceneName: string, id_path: string, language_id: string, sublink: string) => `/v1/projects/sublink/scene/${sceneName}/hotspots?id_path=${id_path}&language_id=${language_id}&link_id=${sublink}`,
        GET_ASSET_BY_CATEGORY_WITH_SUBLINK: (category_uuid: string, idPath: string, sublink: string, limit?: number, page?: number) => withIdPath(`/v1/projects/sublink/${sublink}/category/${category_uuid}/assets?page=${page}&limit=${limit}`, idPath),
        GET_NESTED_CATEGORIES_WITH_SUBLINK: (id_path: string, type_id: any, sublink: string, language_id?: string) => `/v1/projects/sublink/${sublink}/categories-assets/${type_id}?language_id=${language_id}&id_path=${id_path}`,
        GET_ALL_AUTOTOURS_WITH_SUBLINK: (id_path: string, sublink: string, language_id: string, page?: string, limit?: string) => withIdPath(`/v1/projects/sublink/${sublink}/autotours?page=${page}&limit=${limit}&language_id=${language_id}&only_visible=true`, id_path),
        GET_ALL_SUBLINKS: ({ id_path, page, limit, search, sort, order }: { id_path: string, page?: number, limit?: number, search?: string, sort?: string, order?: string }) => {
            let url = `/v1/projects/sublink?id_path=${encodeURIComponent(id_path)}`;
            if (page !== undefined) url += `&page=${page}`;
            if (limit !== undefined) url += `&limit=${limit}`;
            if (search) url += `&search=${encodeURIComponent(search)}`;
            if (sort) url += `&sort=${sort}`;
            if (order) url += `&order=${order}`;
            return url;
        },
    },
    voice: {
        GET_VOICE_BY_TYPE_ID_AND_LANGUAGE: (type: string, id: string, language_id: string, id_path: string) => `v1/projects/voice/entity-type/${type}/entity-id/${id}/language/${language_id}?id_path=${id_path}`,
        GET_VOICE_BY_TYPE_ID_LANGUAGE_AND_GENDER: (type: string, id: string, language_id: string, gender: string, id_path: string) => `v1/projects/voice/entity-type/${type}/entity-id/${id}/language/${language_id}/gender/${gender}?id_path=${id_path}`,
        GET_VOICE_BY_SCENE_NAME: (scene_name: string, language_id: string, gender: string, id_path: string) => `v1/projects/voice/scene/${scene_name}?language_id=${language_id}&gender=${gender}&id_path=${id_path}`
    },
    lists: {
        GET_ALL_LISTS: (id_path?: string, language_id?: string, scene_name?: string) => {
            let url = `/v1/projects/lists`;
            const params: string[] = [];
            if (language_id) params.push(`language_id=${language_id}`);
            if (scene_name) params.push(`scene_name=${encodeURIComponent(scene_name)}`);
            if (params.length > 0) url += `?${params.join('&')}`;
            return withIdPath(url, id_path);
        },
        GET_LIST_BY_ID: (id: string, id_path?: string) => withIdPath(`/v1/projects/lists/${id}`, id_path),
    },
    arNavigation: {
        GET_ALL_DESTINATIONS: (id_path: string, language_id?: string) => {
            let url = `/v1/projects/ar-navigation-destinations`;
            const params: string[] = [];
            if (language_id) params.push(`language_id=${language_id}`);
            params.push(`is_active=1`); // Only get active destinations
            if (params.length > 0) url += `?${params.join('&')}`;
            return withIdPath(url, id_path);
        },
        GET_DESTINATION_BY_ID: (id_path: string, destination_id: string, language_id?: string) => {
            let url = `/v1/projects/ar-navigation-destinations/${destination_id}`;
            if (language_id) url += `?language_id=${language_id}`;
            return withIdPath(url, id_path);
        },
    },
};

export default apiEndPointList;
